import React, { FC } from 'react';

interface InfoItemProps {
  title: string;
  content: string;
  className?: string;
  redContent?: boolean;
}

export const InfoItem: FC<InfoItemProps> = ({ title, content, className, redContent = false }) => {
  return (
    <div className={`${className} grid grid-cols-2 items-center w-2/3`}>
      <p className="text-13 text-gray-500">{title}</p>
      <p className={`font-semibold ${redContent && 'text-red-600'}`}>{content}</p>
    </div>
  );
};
